import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import classes from "./CustomTimer.module.css";

const CustomTimer = (props) => {
  const [time, setTime] = useState(Date.now() + props.delay);

  useEffect(() => {
    //props.resendCodeAndRenderTimer();
    //props.sendCode();
  }, [time]);

  const renderer = ({ minutes, seconds, completed }) => {
    if(completed) props.handleTimeCompleted();
    return (
      <div className={classes.timer}>
        <span className={classes.countDown}>
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
        <Button
          className={classes.resendButton}
          onClick={resendCode}
          // disabled={!completed}
        >
          Resend Code
        </Button>
      </div>
    );
  };

  const resendCode = () => {
    props.sendCode();
    setTime(Date.now() + props.delay);
  };

  return (
    <Countdown date={time} renderer={renderer} ref={props.timer}></Countdown>
  );
};

export default CustomTimer;
